module.exports = __webpack_public_path__ + "img/ALTS_logo_ru2.bc4497ec.png";